import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'auto-advanced-service-categories',
  templateUrl: './service-categories.component.html',
  styleUrls: ['./service-categories.component.scss']
})
export class AdvancedServiceCategoriesComponent implements OnInit, OnChanges {
  @Input() data: any | null = null;
  @Input() options: { value: number; label: string }[] = [];
  @Output() dataEmitter = new EventEmitter<UntypedFormGroup>();
  form: UntypedFormGroup;

  // Column properties for 3-column layout
  leftOptions: { value: number; label: string }[] = [];
  centerOptions: { value: number; label: string }[] = [];
  rightOptions: { value: number; label: string }[] = [];

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    if (!this.options || this.options.length === 0) {
      this.options = [
        { value: 1,  label: 'Oil Change' },
        { value: 2,  label: 'Brakes' },
        { value: 3,  label: 'Coolant Flush' },
        { value: 4,  label: 'Tire' },
        { value: 5,  label: 'Check Engine' },
        { value: 6,  label: 'AC Services' },
        { value: 7,  label: 'Battery' },
        { value: 8,  label: 'Suspension' },
        { value: 9,  label: 'Wipers Blades' },
        { value: 10, label: 'Auto Detailing' },
        { value: 11, label: 'Maintenance' },
        { value: 12, label: 'Auto Body' },
        { value: 13, label: 'Belts Hoses' },
        { value: 14, label: 'Electrical' },
        { value: 15, label: 'Exhaust' },
        { value: 16, label: 'Fall Winter' },
        { value: 17, label: 'Heating Cooling' },
        { value: 18, label: 'Lighting' },
        { value: 19, label: 'Parts Accessories' },
        { value: 20, label: 'Spring Summer' },
        { value: 21, label: 'Transmission' }
      ];
    }
    this.options = this.options.sort((a, b) => a.label.localeCompare(b.label));
    this.splitOptionsIntoColumns();

    const initialSelected = this.normalizeIds(
      this.data?.accountAvailableServiceCategories ?? this.data?.availableServiceCategories ?? []
    );

    this.form = this.formBuilder.group({
      accountAvailableServiceCategories: new UntypedFormControl(initialSelected)
    });

    this.dataEmitter.emit(this.form);
    this.form.markAsPristine();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.form) {
      const nextSelected = this.normalizeIds(
        changes['data'].currentValue?.accountAvailableServiceCategories
        ?? changes['data'].currentValue?.availableServiceCategories
        ?? []
      );
      this.form.get('accountAvailableServiceCategories')?.setValue(nextSelected, { emitEvent: false });
      this.form.markAsPristine();
    }
  }

  // Method to split options into 3 columns
  private splitOptionsIntoColumns(): void {
    const totalItems = this.options.length;
    const itemsPerColumn = Math.ceil(totalItems / 3);

    this.leftOptions = this.options.slice(0, itemsPerColumn);
    this.centerOptions = this.options.slice(itemsPerColumn, itemsPerColumn * 2);
    this.rightOptions = this.options.slice(itemsPerColumn * 2);
  }

  private normalizeIds(values: any[]): number[] {
    return Array.from(new Set((values || []).map(v => parseInt(v, 10)).filter(v => !isNaN(v))));
  }

  isSelected(optionId: number): boolean {
    const selected = this.form.get('accountAvailableServiceCategories')?.value as number[];
    return Array.isArray(selected) && selected.includes(optionId);
  }

  toggleCategory(optionId: number, checked: boolean): void {
    const ctrl = this.form.get('accountAvailableServiceCategories');
    const current: number[] = Array.isArray(ctrl?.value) ? [...ctrl!.value] : [];
    const next = new Set(current);

    if (checked){
      next.add(optionId);
    } else {
      next.delete(optionId);
    }

    ctrl?.setValue(Array.from(next));
    this.form.markAsDirty();
  }
}
